import React, { useEffect, useState } from 'react';
import { ArrowRightCircle, Edit, Plus, RefreshCw, Trash2, Search, Filter, Calendar, User, Building2, Briefcase, ChevronLeft, ChevronRight, X, Info } from 'lucide-react';
import http from '../api/http';
import { useAuth } from '../context/AuthContext';
import { useFiliale } from '../context/FilialeContext';
import BlueHeader from '../components/BlueHeader';

const MouvementsCarriere = () => {
  const { user } = useAuth();
  const { filialeId, currentFiliale } = useFiliale();
  const [mouvements, setMouvements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showEmployeeModal, setShowEmployeeModal] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [typesMouvements, setTypesMouvements] = useState([]);
  const [activeTab, setActiveTab] = useState(1);
  const [dropdownData, setDropdownData] = useState({
    personnel: [],
    filiales: [],
    departements: [],
    titres: [],
    marques: [],
    clients: [],
    campagnes: [],
    activites: [],
    managers: []
  });
  const [filters, setFilters] = useState({
    personnel_id: '',
    type_mouvement: '',
    date_debut: '',
    date_fin: ''
  });
  const [formData, setFormData] = useState({
    personnel_id: '',
    date_effet: '',
    date_fin: '',
    pays_id: '',
    filiale_id: '',
    marque_id: '',
    departement_id: '',
    client_id: '',
    campagne_id: '',
    activite_id: '',
    titre_id: '',
    manager_hierarchique_id: '',
    type_contrat: '',
    motif_changement: ''
  });
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [employeeSearch, setEmployeeSearch] = useState('');
  const [selectedManager, setSelectedManager] = useState(null);
  const [managerSearch, setManagerSearch] = useState('');
  const [showManagerModal, setShowManagerModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [sortField, setSortField] = useState('date_effet');
  const [sortOrder, setSortOrder] = useState('desc');

  // Charger les données dropdown
  const fetchDropdownData = async () => {
    try {
      const personnelUrl = (filialeId && filialeId !== 'all') 
        ? `/api/personnel?filiale_id=${filialeId}` 
        : '/api/personnel';
      const titresUrl = (filialeId && filialeId !== 'all') 
        ? `/api/titres?filiale_id=${filialeId}` 
        : '/api/titres';
      const campagnesUrl = (filialeId && filialeId !== 'all') 
        ? `/api/campagnes?filiale_id=${filialeId}` 
        : '/api/campagnes';

      const [personnel, filiales, departements, titres, marques, clients, campagnes, activites, managers] = await Promise.all([
        http.get(personnelUrl),
        http.get('/api/filiales'),
        http.get('/api/departements'),
        http.get(titresUrl),
        http.get('/api/marques'),
        http.get('/api/clients'),
        http.get(campagnesUrl),
        http.get('/api/activites'),
        http.get('/api/personnel/managers')
      ]);

      const personnelArray = Array.isArray(personnel.data) ? personnel.data : 
                             (personnel.data && personnel.data.data && Array.isArray(personnel.data.data) ? personnel.data.data : []);
      
      const managersArray = Array.isArray(managers.data) ? managers.data : 
                             (managers.data && managers.data.data && Array.isArray(managers.data.data) ? managers.data.data : []);

      setDropdownData({
        personnel: personnelArray,
        filiales: Array.isArray(filiales.data) ? filiales.data : [],
        departements: Array.isArray(departements.data) ? departements.data : [],
        titres: Array.isArray(titres.data) ? titres.data : [],
        marques: Array.isArray(marques.data) ? marques.data : [],
        clients: Array.isArray(clients.data) ? clients.data : [],
        campagnes: Array.isArray(campagnes.data) ? campagnes.data : [],
        activites: Array.isArray(activites.data) ? activites.data : [],
        managers: managersArray
      });
    } catch (error) {
      console.error('Erreur chargement dropdown:', error);
    }
  };

  // Charger les mouvements
  const fetchMouvements = async () => {
    try {
      setLoading(true);
      const params = {};
      
      if (filialeId && filialeId !== 'all') {
        params.filiale_id = filialeId;
      }
      
      if (filters.personnel_id) {
        params.personnel_id = filters.personnel_id;
      }
      
      if (filters.type_mouvement) {
        params.type_mouvement = filters.type_mouvement;
      }
      
      if (filters.date_debut) {
        params.date_debut = filters.date_debut;
      }
      
      if (filters.date_fin) {
        params.date_fin = filters.date_fin;
      }
      
      const response = await http.get('/api/mouvements-carriere', { params });
      setMouvements(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error('Erreur chargement mouvements:', error);
      setMouvements([]);
    } finally {
      setLoading(false);
    }
  };

  // Charger les types de mouvements
  const fetchTypesMouvements = async () => {
    try {
      const response = await http.get('/api/mouvements-carriere/types');
      setTypesMouvements(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error('Erreur chargement types mouvements:', error);
      setTypesMouvements([]);
    }
  };

  useEffect(() => {
    fetchDropdownData();
    fetchMouvements();
    fetchTypesMouvements();
  }, [filialeId]);

  useEffect(() => {
    fetchMouvements();
  }, [filters]);

  const handleCreate = () => {
    setEditingItem(null);
    setActiveTab(1);
    setFormData({
      personnel_id: '',
      date_effet: '',
      date_fin: '',
      pays_id: '',
      filiale_id: filialeId || '',
      marque_id: '',
      departement_id: '',
      client_id: '',
      campagne_id: '',
      activite_id: '',
      titre_id: '',
      manager_hierarchique_id: '',
      type_contrat: '',
      motif_changement: ''
    });
    setSelectedEmployee(null);
    setShowModal(true);
  };

  const handleEdit = (item) => {
    setEditingItem(item);
    setActiveTab(1);
    setFormData({ ...item });
    const emp = dropdownData.personnel.find(p => p.idpersonnel === item.personnel_id);
    setSelectedEmployee(emp || null);
    setShowModal(true);
  };

  const handleSelectEmployee = (employee) => {
    setSelectedEmployee(employee);
    setFormData({ 
      ...formData, 
      personnel_id: employee.idpersonnel,
      filiale_id: employee.filiale_id || filialeId || '',
      marque_id: employee.marque_id || '',
      departement_id: employee.departement_id || '',
      titre_id: employee.titre_id || '',
      manager_hierarchique_id: employee.manager_hierarchique_id || '',
      type_contrat: employee.type_contrat || '',
      idcampagne: employee.idcampagne || ''
    });
    setShowEmployeeModal(false);
  };

  const handleSelectManager = (manager) => {
    setSelectedManager(manager);
    setFormData({ ...formData, manager_hierarchique_id: manager.idpersonnel });
    setShowManagerModal(false);
  };

  const filteredEmployees = dropdownData.personnel.filter(emp =>
    `${emp.prenom} ${emp.nom}`.toLowerCase().includes(employeeSearch.toLowerCase())
  );

  const filteredManagers = dropdownData.managers.filter(m =>
    `${m.prenom} ${m.nom}`.toLowerCase().includes(managerSearch.toLowerCase())
  );

  // Filtrer et trier les mouvements
  const filteredMouvements = mouvements.filter(m => {
    const searchLower = searchTerm.toLowerCase();
    return (
      (m.prenom && m.prenom.toLowerCase().includes(searchLower)) ||
      (m.nom && m.nom.toLowerCase().includes(searchLower)) ||
      (m.motif_changement && m.motif_changement.toLowerCase().includes(searchLower)) ||
      (m.titre_nom && m.titre_nom.toLowerCase().includes(searchLower)) ||
      (m.departement_nom && m.departement_nom.toLowerCase().includes(searchLower))
    );
  }).sort((a, b) => {
    const aValue = a[sortField] || '';
    const bValue = b[sortField] || '';
    
    if (sortOrder === 'asc') {
      return aValue > bValue ? 1 : -1;
    } else {
      return aValue < bValue ? 1 : -1;
    }
  });

  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentMouvements = filteredMouvements.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredMouvements.length / itemsPerPage);

  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortOrder('asc');
    }
  };

  const getSortIcon = (field) => {
    if (sortField !== field) return null;
    return sortOrder === 'asc' ? '↑' : '↓';
  };

  const getMotifColor = (motif) => {
    const colors = {
      'promotion': 'bg-green-100 text-green-800',
      'mutation': 'bg-blue-100 text-blue-800',
      'changement_departement': 'bg-purple-100 text-purple-800',
      'changement_titre': 'bg-orange-100 text-orange-800',
      'changement_contrat': 'bg-yellow-100 text-yellow-800',
      'mobilité': 'bg-cyan-100 text-cyan-800',
      'demission': 'bg-red-100 text-red-800',
      'licenciement': 'bg-red-100 text-red-800',
      'retraite': 'bg-gray-100 text-gray-800'
    };
    return colors[motif] || 'bg-gray-100 text-gray-800';
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Êtes-vous sûr de vouloir supprimer ce mouvement de carrière ?')) return;

    try {
      await http.delete(`/api/mouvements-carriere/${id}`);
      fetchMouvements();
    } catch (error) {
      alert('Erreur lors de la suppression: ' + (error.response?.data?.error || 'Erreur inconnue'));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingItem) {
        await http.put(`/api/mouvements-carriere/${editingItem.id}`, formData);
      } else {
        await http.post('/api/mouvements-carriere', formData);
      }
      setShowModal(false);
      fetchMouvements();
    } catch (error) {
      alert('Erreur: ' + (error.response?.data?.error || 'Erreur inconnue'));
    }
  };

  const getPersonnelNom = (id) => {
    const p = dropdownData.personnel.find(p => p.idpersonnel === id);
    return p ? `${p.prenom} ${p.nom}` : '-';
  };

  const getFilialeNom = (id) => {
    const f = dropdownData.filiales.find(f => f.idfiliale === id);
    return f ? f.libelle : '-';
  };

  const getDepartementNom = (id) => {
    const d = dropdownData.departements.find(d => d.iddepartement === id);
    return d ? d.libelle_departement : '-';
  };

  const getTitreNom = (id) => {
    const t = dropdownData.titres.find(t => t.idtitre === id);
    return t ? t.nom_developpe : '-';
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <BlueHeader
        title="Mouvements de Carrière"
        description="Gestion des promotions, mutations et mobilités"
        icon={ArrowRightCircle}
        actions={[
          {
            label: 'Nouveau mouvement',
            icon: Plus,
            onClick: handleCreate,
            primary: true
          },
          {
            label: 'Actualiser',
            icon: RefreshCw,
            onClick: fetchMouvements,
            primary: false
          }
        ]}
      />

      <div className="px-6 py-8">
        {/* Filtres et recherche */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4 mb-6">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-2">
              <Filter className="h-5 w-5 text-gray-500" />
              <h3 className="font-semibold text-gray-700">Filtres</h3>
            </div>
            <div className="relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
              <input
                type="text"
                placeholder="Rechercher..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg w-64"
              />
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Employé</label>
              <select
                value={filters.personnel_id}
                onChange={(e) => setFilters({ ...filters, personnel_id: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-md"
              >
                <option key="all-personnel" value="">Tous</option>
                {dropdownData.personnel.map(p => (
                  <option key={p.idpersonnel} value={p.idpersonnel}>{p.prenom} {p.nom}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Type de mouvement</label>
              <select
                value={filters.type_mouvement}
                onChange={(e) => setFilters({ ...filters, type_mouvement: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-md"
              >
                <option key="all-type" value="">Tous</option>
                {typesMouvements.map(t => (
                  <option key={t.code} value={t.code}>{t.libelle}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Date début</label>
              <input
                type="date"
                value={filters.date_debut}
                onChange={(e) => setFilters({ ...filters, date_debut: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-md"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Date fin</label>
              <input
                type="date"
                value={filters.date_fin}
                onChange={(e) => setFilters({ ...filters, date_fin: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-md"
              />
            </div>
          </div>
        </div>

        {/* Tableau */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
          {loading ? (
            <div className="flex h-48 items-center justify-center text-sm text-gray-500">
              Chargement...
            </div>
          ) : currentMouvements.length === 0 ? (
            <div className="px-4 py-16 text-center text-sm text-gray-500">
              Aucun mouvement de carrière trouvé.
            </div>
          ) : (
            <>
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th 
                        className="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase cursor-pointer hover:bg-gray-100"
                        onClick={() => handleSort('nom')}
                      >
                        Employé {getSortIcon('nom')}
                      </th>
                      <th 
                        className="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase cursor-pointer hover:bg-gray-100"
                        onClick={() => handleSort('motif_changement')}
                      >
                        Type {getSortIcon('motif_changement')}
                      </th>
                      <th 
                        className="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase cursor-pointer hover:bg-gray-100"
                        onClick={() => handleSort('date_effet')}
                      >
                        Date effet {getSortIcon('date_effet')}
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase">Filiale</th>
                      <th className="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase">Département</th>
                      <th className="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase">Titre</th>
                      <th className="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase">Actions</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    {currentMouvements.map((mouvement) => (
                      <tr key={mouvement.id} className="hover:bg-gray-50">
                        <td className="px-6 py-4 text-sm font-medium text-gray-900">
                          {mouvement.prenom} {mouvement.nom}
                        </td>
                        <td className="px-6 py-4 text-sm">
                          <span className={`px-2 py-1 rounded-full text-xs font-medium ${getMotifColor(mouvement.motif_changement)}`}>
                            {mouvement.motif_changement.replace(/_/g, ' ')}
                          </span>
                        </td>
                        <td className="px-6 py-4 text-sm text-gray-700">
                          {new Date(mouvement.date_effet).toLocaleDateString('fr-FR')}
                        </td>
                        <td className="px-6 py-4 text-sm text-gray-700">
                          <span className="px-2 py-1 bg-blue-50 text-blue-700 rounded text-xs">
                            {mouvement.filiale_nom || '-'}
                          </span>
                        </td>
                        <td className="px-6 py-4 text-sm text-gray-700">
                          <span className="px-2 py-1 bg-purple-50 text-purple-700 rounded text-xs">
                            {mouvement.departement_nom || '-'}
                          </span>
                        </td>
                        <td className="px-6 py-4 text-sm text-gray-700">
                          <span className="px-2 py-1 bg-orange-50 text-orange-700 rounded text-xs">
                            {mouvement.titre_nom || '-'}
                          </span>
                        </td>
                        <td className="px-6 py-4 text-sm">
                          <div className="flex gap-2">
                            <button
                              onClick={() => handleEdit(mouvement)}
                              className="text-blue-600 hover:text-blue-800"
                            >
                              <Edit className="h-4 w-4" />
                            </button>
                            <button
                              onClick={() => handleDelete(mouvement.id)}
                              className="text-red-600 hover:text-red-800"
                            >
                              <Trash2 className="h-4 w-4" />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              <div className="px-6 py-4 border-t bg-gray-50 flex items-center justify-between">
                <div className="text-sm text-gray-600">
                  Affichage de {indexOfFirstItem + 1} à {Math.min(indexOfLastItem, filteredMouvements.length)} sur {filteredMouvements.length} mouvements
                </div>
                <div className="flex gap-2">
                  <button
                    onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
                    disabled={currentPage === 1}
                    className="px-3 py-1 border border-gray-300 rounded hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Précédent
                  </button>
                  {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                    <button
                      key={page}
                      onClick={() => setCurrentPage(page)}
                      className={`px-3 py-1 border rounded ${
                        currentPage === page
                          ? 'bg-blue-600 text-white border-blue-600'
                          : 'border-gray-300 hover:bg-gray-100'
                      }`}
                    >
                      {page}
                    </button>
                  ))}
                  <button
                    onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
                    disabled={currentPage === totalPages}
                    className="px-3 py-1 border border-gray-300 rounded hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Suivant
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      {/* Modal Mouvement */}
      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
          <div className="w-full max-w-4xl rounded-xl bg-white shadow-2xl max-h-[90vh] overflow-hidden flex flex-col">
            {/* Header */}
            <div className="px-6 py-4 border-b bg-gray-50">
              <div className="flex items-center justify-between">
                <h3 className="text-lg font-bold text-gray-900">
                  {editingItem ? 'Modifier' : 'Créer'} Mouvement de Carrière
                </h3>
                <button
                  onClick={() => setShowModal(false)}
                  className="text-gray-500 hover:text-gray-900"
                >
                  <X className="h-5 w-5" />
                </button>
              </div>
              <div className="mt-2 flex items-start gap-2 bg-blue-50 border border-blue-200 rounded-md p-3">
                <Info className="h-5 w-5 text-blue-600 flex-shrink-0 mt-0.5" />
                <p className="text-sm text-blue-800">
                  Ce mouvement mettra automatiquement à jour la fiche employé avec les nouvelles informations (département, titre, manager, etc.).
                </p>
              </div>
            </div>

            {/* Onglets */}
            <div className="border-b bg-white">
              <div className="flex">
                <button
                  key="tab-1"
                  onClick={() => setActiveTab(1)}
                  className={`px-6 py-3 font-medium text-sm border-b-2 transition-colors ${
                    activeTab === 1
                      ? 'border-blue-600 text-blue-600 bg-blue-50'
                      : 'border-transparent text-gray-500 hover:text-gray-700'
                  }`}
                >
                  Informations générales
                </button>
                <button
                  key="tab-2"
                  onClick={() => setActiveTab(2)}
                  className={`px-6 py-3 font-medium text-sm border-b-2 transition-colors ${
                    activeTab === 2
                      ? 'border-blue-600 text-blue-600 bg-blue-50'
                      : 'border-transparent text-gray-500 hover:text-gray-700'
                  }`}
                >
                  Affectation organisationnelle
                </button>
                <button
                  key="tab-3"
                  onClick={() => setActiveTab(3)}
                  className={`px-6 py-3 font-medium text-sm border-b-2 transition-colors ${
                    activeTab === 3
                      ? 'border-blue-600 text-blue-600 bg-blue-50'
                      : 'border-transparent text-gray-500 hover:text-gray-700'
                  }`}
                >
                  Portefeuille & Activité
                </button>
              </div>
            </div>

            {/* Contenu */}
            <div className="flex-1 overflow-y-auto p-6">
              <form onSubmit={handleSubmit} className="space-y-6">
                {/* Onglet 1: Informations générales */}
                {activeTab === 1 && (
                  <div className="space-y-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Employé *</label>
                        <div className="flex gap-2">
                          <input
                            type="text"
                            value={selectedEmployee ? `${selectedEmployee.prenom} ${selectedEmployee.nom}` : ''}
                            readOnly
                            className="flex-1 px-3 py-2 border border-gray-300 rounded-md bg-gray-50"
                            placeholder="Sélectionner un employé"
                          />
                          <button
                            type="button"
                            onClick={() => setShowEmployeeModal(true)}
                            className="px-3 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                          >
                            <User className="h-4 w-4" />
                          </button>
                        </div>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Type de mouvement *</label>
                        <select
                          value={formData.motif_changement}
                          onChange={(e) => setFormData({ ...formData, motif_changement: e.target.value })}
                          className="w-full px-3 py-2 border border-gray-300 rounded-md"
                          required
                        >
                          <option key="select-motif" value="">Sélectionner</option>
                          {typesMouvements.map(t => (
                            <option key={t.code} value={t.code}>{t.libelle}</option>
                          ))}
                        </select>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Date d'effet *</label>
                        <input
                          type="date"
                          value={formData.date_effet}
                          onChange={(e) => setFormData({ ...formData, date_effet: e.target.value })}
                          className="w-full px-3 py-2 border border-gray-300 rounded-md"
                          required
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Date de fin</label>
                        <input
                          type="date"
                          value={formData.date_fin}
                          onChange={(e) => setFormData({ ...formData, date_fin: e.target.value })}
                          className="w-full px-3 py-2 border border-gray-300 rounded-md"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Type de contrat</label>
                        <select
                          value={formData.type_contrat}
                          onChange={(e) => setFormData({ ...formData, type_contrat: e.target.value })}
                          className="w-full px-3 py-2 border border-gray-300 rounded-md"
                        >
                          <option key="select-contrat" value="">Sélectionner</option>
                          <option key="stage" value="STAGE">Stage</option>
                          <option key="cdd" value="CDD">CDD</option>
                          <option key="cdi" value="CDI">CDI</option>
                          <option key="formation" value="FORMATION">Formation</option>
                          <option key="prestataire" value="PRESTATAIRE">Prestataire</option>
                        </select>
                      </div>
                    </div>
                  </div>
                )}

                {/* Onglet 2: Affectation organisationnelle */}
                {activeTab === 2 && (
                  <div className="space-y-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Département</label>
                        <select
                          value={formData.departement_id}
                          onChange={(e) => setFormData({ ...formData, departement_id: e.target.value })}
                          className="w-full px-3 py-2 border border-gray-300 rounded-md"
                        >
                          <option key="select-dept" value="">Sélectionner</option>
                          {dropdownData.departements.map(d => (
                            <option key={d.iddepartement} value={d.iddepartement}>{d.libelle_departement}</option>
                          ))}
                        </select>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Titre/Fonction</label>
                        <select
                          value={formData.titre_id}
                          onChange={(e) => setFormData({ ...formData, titre_id: e.target.value })}
                          className="w-full px-3 py-2 border border-gray-300 rounded-md"
                        >
                          <option key="select-titre" value="">Sélectionner</option>
                          {dropdownData.titres.map(t => (
                            <option key={t.idtitre} value={t.idtitre}>{t.nom_developpe}</option>
                          ))}
                        </select>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Manager hiérarchique</label>
                        <div className="flex gap-2">
                          <input
                            type="text"
                            value={selectedManager ? `${selectedManager.prenom} ${selectedManager.nom}` : ''}
                            readOnly
                            className="flex-1 px-3 py-2 border border-gray-300 rounded-md bg-gray-50"
                            placeholder="Sélectionner un manager"
                          />
                          <button
                            type="button"
                            onClick={() => setShowManagerModal(true)}
                            className="px-3 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                          >
                            <User className="h-4 w-4" />
                          </button>
                        </div>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Marque</label>
                        <select
                          value={formData.marque_id}
                          onChange={(e) => setFormData({ ...formData, marque_id: e.target.value })}
                          className="w-full px-3 py-2 border border-gray-300 rounded-md"
                        >
                          <option key="select-marque" value="">Sélectionner</option>
                          {dropdownData.marques.map(m => (
                            <option key={m.id} value={m.id}>{m.libelle}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                )}

                {/* Onglet 3: Portefeuille & Activité */}
                {activeTab === 3 && (
                  <div className="space-y-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Client</label>
                        <select
                          value={formData.client_id}
                          onChange={(e) => setFormData({ ...formData, client_id: e.target.value })}
                          className="w-full px-3 py-2 border border-gray-300 rounded-md"
                        >
                          <option key="select-client" value="">Sélectionner</option>
                          {dropdownData.clients && Array.isArray(dropdownData.clients) && dropdownData.clients.map(c => (
                            <option key={c.idclient} value={c.idclient}>{c.Libelle_client}</option>
                          ))}
                        </select>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Campagne</label>
                        <select
                          value={formData.campagne_id}
                          onChange={(e) => setFormData({ ...formData, campagne_id: e.target.value })}
                          className="w-full px-3 py-2 border border-gray-300 rounded-md"
                        >
                          <option key="select-campagne" value="">Sélectionner</option>
                          {dropdownData.campagnes && Array.isArray(dropdownData.campagnes) && dropdownData.campagnes.map(c => (
                            <option key={c.idcampagne} value={c.idcampagne}>{c.Libelle_campagne}</option>
                          ))}
                        </select>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Activité</label>
                        <select
                          value={formData.activite_id}
                          onChange={(e) => setFormData({ ...formData, activite_id: e.target.value })}
                          className="w-full px-3 py-2 border border-gray-300 rounded-md"
                        >
                          <option key="select-activite" value="">Sélectionner</option>
                          {dropdownData.activites && Array.isArray(dropdownData.activites) && dropdownData.activites.map(a => (
                            <option key={a.idactivites} value={a.idactivites}>{a.Libelle_activite}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                )}
              </form>
            </div>

            {/* Footer */}
            <div className="px-6 py-4 border-t bg-gray-50 flex items-center justify-between">
              <div className="flex gap-2">
                <button
                  type="button"
                  onClick={() => setActiveTab(Math.max(1, activeTab - 1))}
                  disabled={activeTab === 1}
                  className="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
                >
                  <ChevronLeft className="h-4 w-4" />
                  Précédent
                </button>
                <button
                  type="button"
                  onClick={() => setActiveTab(Math.min(3, activeTab + 1))}
                  disabled={activeTab === 3}
                  className="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
                >
                  Suivant
                  <ChevronRight className="h-4 w-4" />
                </button>
              </div>
              <div className="flex gap-3">
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300"
                >
                  Annuler
                </button>
                <button
                  type="button"
                  onClick={handleSubmit}
                  className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                >
                  {editingItem ? 'Modifier' : 'Créer'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Sélection Employé */}
      {showEmployeeModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
          <div className="w-full max-w-2xl rounded-xl bg-white shadow-2xl max-h-[80vh] overflow-hidden flex flex-col">
            <div className="px-6 py-4 border-b bg-gray-50">
              <div className="flex items-center justify-between">
                <h3 className="text-lg font-bold text-gray-900">Sélectionner un employé</h3>
                <button
                  onClick={() => setShowEmployeeModal(false)}
                  className="text-gray-500 hover:text-gray-900"
                >
                  <X className="h-5 w-5" />
                </button>
              </div>
            </div>
            <div className="p-4 border-b">
              <div className="relative">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
                <input
                  type="text"
                  placeholder="Rechercher un employé..."
                  value={employeeSearch}
                  onChange={(e) => setEmployeeSearch(e.target.value)}
                  className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg"
                />
              </div>
            </div>
            <div className="flex-1 overflow-y-auto">
              {filteredEmployees.length === 0 ? (
                <div className="p-8 text-center text-gray-500">Aucun employé trouvé</div>
              ) : (
                <div className="divide-y">
                  {filteredEmployees.map(emp => (
                    <button
                      key={emp.idpersonnel}
                      type="button"
                      onClick={() => handleSelectEmployee(emp)}
                      className="w-full px-6 py-4 hover:bg-gray-50 flex items-center gap-4 transition-colors"
                    >
                      <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 font-semibold">
                        {emp.prenom[0]}{emp.nom[0]}
                      </div>
                      <div className="flex-1 text-left">
                        <div className="font-medium text-gray-900">{emp.prenom} {emp.nom}</div>
                        <div className="text-sm text-gray-500">{emp.matricule || 'N/A'}</div>
                      </div>
                      <ChevronRight className="h-5 w-5 text-gray-400" />
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Modal Sélection Manager */}
      {showManagerModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
          <div className="w-full max-w-2xl rounded-xl bg-white shadow-2xl max-h-[80vh] overflow-hidden flex flex-col">
            <div className="px-6 py-4 border-b bg-gray-50">
              <div className="flex items-center justify-between">
                <h3 className="text-lg font-bold text-gray-900">Sélectionner un manager</h3>
                <button
                  onClick={() => setShowManagerModal(false)}
                  className="text-gray-500 hover:text-gray-900"
                >
                  <X className="h-5 w-5" />
                </button>
              </div>
            </div>
            <div className="p-4 border-b">
              <div className="relative">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
                <input
                  type="text"
                  placeholder="Rechercher un manager..."
                  value={managerSearch}
                  onChange={(e) => setManagerSearch(e.target.value)}
                  className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg"
                />
              </div>
            </div>
            <div className="flex-1 overflow-y-auto">
              {filteredManagers.length === 0 ? (
                <div className="p-8 text-center text-gray-500">Aucun manager trouvé</div>
              ) : (
                <div className="divide-y">
                  {filteredManagers.map(m => (
                    <button
                      key={m.idpersonnel}
                      type="button"
                      onClick={() => handleSelectManager(m)}
                      className="w-full px-6 py-4 hover:bg-gray-50 flex items-center gap-4 transition-colors"
                    >
                      <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center text-green-600 font-semibold">
                        {m.prenom[0]}{m.nom[0]}
                      </div>
                      <div className="flex-1 text-left">
                        <div className="font-medium text-gray-900">{m.prenom} {m.nom}</div>
                        <div className="text-sm text-gray-500">{m.matricule || 'N/A'}</div>
                      </div>
                      <ChevronRight className="h-5 w-5 text-gray-400" />
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MouvementsCarriere;
